import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router-dom';
import Modal from '../modals/modal';

@inject('store')
@observer
export default class EditDeleteButtons extends React.Component {

  static propTypes = {
    align: PropTypes.string,
    contentId: PropTypes.string.isRequired,
    sectionId: PropTypes.number.isRequired,
    store: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.store = this.props.store;
    this.contentItems = this.props.store.newMasterStore.ContentItems;
    this.alert = this.props.store.newMasterStore.alert;
  }

    confirmDelete = () => {
      this.deleteModal.hideModal(); //Must hide modal before destroying the underlying model
      this.contentItems.pushContentItemDeletion(this.props.contentId).then(() => {
        this.alert.showAlert({type: 'SUCCESS', text: 'Deletion successful.'})
      }).catch(()=>{
        this.alert.showAlert({type: 'ERROR', text: 'Something went wrong. Please try again.'})
      })
    }

    render() {
        return (
            <div className="edit-delete-wrapper">
                <div className={`floating-action-wrapper ${this.props.align}`}>
                    <Link className="floating-action btn" to={`/content/edit/${this.props.sectionId}/${this.props.contentId}`}>
                      <i className="icon icon-pencil" aria-hidden="true"/>
                      Edit
                    </Link>
                    <button className="floating-action btn" onClick={()=>this.deleteModal.showModal()}>
                      <i className="icon icon-trash" aria-hidden="true"/>
                      Delete
                    </button>
                </div>
                <Modal
                    id="delete-modal"
                    title={`Delete "${this.props.title}"?`}
                    ref={i => this.deleteModal = i}
                    restoreFocusTo="#delete-modal-launcher"
                    primaryAction={this.confirmDelete}
                    primaryButtonLabel="Delete Item"
                    secondaryAction={() => this.deleteModal.hideModal()}
                    secondaryButtonLabel="Keep Item">
                    <p>This cannot be undone. New items can be added at any time.</p>
                </Modal>
            </div>
        )
    }
}
